module.exports = __webpack_public_path__ + "static/img/step1.61d4219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step1.png
// module id = j3gX
// module chunks = 1